module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/feedback/manage/manage-feedback/manage-feedback.component.css
// module id = ./src/app/components/feedback/manage/manage-feedback/manage-feedback.component.css
// module chunks = main